import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itemFilter'
})
export class ItemFilter implements PipeTransform {
	transform(value: any, args?: any): any {
		if (value==null) return value;
		if (!args) return value;
		let results = [];

		// Each product
		let productFilter = value.filter(product => {
			// For Items of a product
			let items = product.items;

			let itemFilter = items.filter(productItems => {
				
				// Push ahead if value was found
				if ( productItems.value == args )
					results.push(product);

			});

		});

		return results;
	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/item.filter.pipe.ts